<template>
  <div>
    <Nav></Nav>
    <banner-part :bannerInfo="bannerInfo"></banner-part>
    <!-- 智慧配电网 -->
    <elec-net></elec-net>
    <Footer class="top" />
  </div>
</template>

<script>
import BannerPart from "../components/BannerPart.vue";
import ElecNet from "./components/elecNet.vue";
export default {
  components: {
    BannerPart,
    ElecNet,
  },
  data() {
    return {
      bannerInfo: {
        text1: "智慧配电网",
        text2: "数据贯通、智能分析、自动执行，助力配网业务精益管控",
        swiperImg: require("./images/elecNet/smart-grid-hero.webp"),
        darkLeft: true,
      },
    };
  },
};
</script>
